module.exports = __webpack_public_path__ + "img/analysis_display.b65d69a1.png";